import React from 'react';
import PropTypes from 'prop-types';

import FormActionShape from '../../../../lib/shapes/FormActionShape';

// Components
import Form from '../../../molecules/Form';
import { RequestActivityFormTemplate } from './RequestActivityFormTemplate';

export function RequestActivityForm({ form, translationNamespace, refreshBlock, readRestricted = false }) {
  const onSuccess = () => {
    if (!readRestricted) {
      setTimeout(() => {
        refreshBlock();
      }, 2000);
    }
  };

  return (
    <Form id="teamroom-request-activation-form" model={form} submittableWithoutChange onSuccess={onSuccess}>
      <RequestActivityFormTemplate translationNamespace={translationNamespace} readRestricted={readRestricted} />
    </Form>
  );
}

RequestActivityForm.propTypes = {
  form: FormActionShape.isRequired,
  translationNamespace: PropTypes.string.isRequired,
  refreshBlock: PropTypes.func.isRequired,
  readRestricted: PropTypes.bool,
};
